import { render, staticRenderFns } from "./ImportTags.vue?vue&type=template&id=cc6dcef2"
import script from "./ImportTags.vue?vue&type=script&lang=js"
export * from "./ImportTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports